import { DateInput } from '@framework/form/inputs/DateInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.DateRange}`;

export interface IDateRangeRuleComponentProps {}

export function DateRangeRuleComponent(props: IDateRangeRuleComponentProps) {
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.fromDate`}
        label="Dal"
        help="La data si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <DateInput name={`${fieldName}.fromDate`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>

      <FormItem
        name={`${fieldName}.toDate`}
        label="Al"
        help="La data si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <DateInput name={`${fieldName}.toDate`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
